import { Methods } from "./api";

export type UrlInterface = {
  url: string;
  method: Methods;
  fields: any;
};

export type Picture = {
  low: string;
  medium: string;
  high: string;
  original: string;
} | null;

export interface ImageType {
  path: string | null,
  alt: string
}

export type UserInterface = {
  id: number;
  displayName: string;
  token: string;
  image: ImageType;
  email: string;
  verifiedAccount: boolean;
  speciality: string | null
  backgroundPicture: string | null;
  title: string | null;
  physicianId: string | null;
};

export enum ClaimType {
  Physician = "physician",
  Hospital = "hospital",
  Clinic = "clinic",
  OHCP = "other healthcare",
  NFP = "nfp",
  BUSINESS = "Business"
}

export type DetailsInterface = {
  id: string;
  searchName: string;
  redirectLink: string;
  distance: [number];
  itemType: string;
  rating: number;
  ratingCount: number;
  location: string;
  phoneNumber: string;
  address: string;
  extraFilters: any;
  speciality: string;
  reviewUrl: UrlInterface;
  picture: string;
}

export type MarkerInterface = {
  coordinates: [number, number];
  count: number;
  detailsUrl: UrlInterface | null;
  data: DetailsInterface | null;
  geohash: string;
}
